import { Theme } from "../../../../../../providers/ThemeProvider";

export type MacroColors = { carbs: string; protein: string; fat: string };

/**
 * Macro colours from the existing token scales, chosen as the closest match
 * to the mobile app's yellow / green / blue (Warning 50, Success 50, Primary 50).
 */
export const getMacroColors = (theme: Theme): MacroColors => ({
  carbs: theme.colorTokens.W[50],
  protein: theme.colorTokens.S[50],
  fat: theme.colorTokens.P[50],
});
